import React, { type FunctionComponent } from 'react'
import { Button, PageHeader } from '@retailer-platform/shared-components'
import { ListAccountsBreadcrumbs } from 'domains/account-management/components/accounts-list/components/breadcrumbs/ListAccountsBreadcrumbs'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { AccountManagementListAccounts } from 'domains/account-management/components/accounts-list/AccountManagementListAccounts'
import { accountManagementWrapperStyles } from 'domains/account-management/styles/accountManagement.styles'
import { useGoToPath } from 'utils/routing/navigation.hooks'
import { useDomainMessage } from 'domains/account-management/utils/domain/intl'
import { useWarehouseContext } from 'utils/contexts/warehouse/WarehouseContext.hooks'

interface Props extends DashRouteComponentProps<{ partner_id: string }> {}

export const AccountManagementListAccountsPage: FunctionComponent<Props> = ({ match }) => {
  const partnerId = match?.params?.partner_id

  const addAccountMessage = useDomainMessage('accountManagementDomain.addAccount')
  const goToNewAccount = useGoToPath('retailer-account-management-create')
  const createUser = <Button onClick={goToNewAccount}>{addAccountMessage}</Button>
  const warehouseContext = useWarehouseContext()

  return (
    <div css={accountManagementWrapperStyles}>
      <DocumentTitle titleId="accountManagementDomain.list.pageTitle" />
      <PageHeader title={<ListAccountsBreadcrumbs />} actions={createUser} />

      <AccountManagementListAccounts
        partnerId={partnerId}
        partnerName={warehouseContext.partnerName}
      />
    </div>
  )
}
